import { render, staticRenderFns } from "./ListOnSchemaAddressesEditor.vue?vue&type=template&id=61ccec7f&scoped=true&"
import script from "./ListOnSchemaAddressesEditor.vue?vue&type=script&lang=js&"
export * from "./ListOnSchemaAddressesEditor.vue?vue&type=script&lang=js&"
import style0 from "./ListOnSchemaAddressesEditor.vue?vue&type=style&index=0&id=61ccec7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ccec7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
